var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "", tile: "", color: "grey lighten-4" } },
    [
      _c("v-card-title", [
        _c("h3", { staticClass: "checkout-section-title mx-auto mb-2" }, [
          _vm._v(" " + _vm._s(_vm.$t("checkout.yourOrder")) + " ")
        ])
      ]),
      _c(
        "v-card-text",
        { staticClass: "pa-md-4 pa-0" },
        [
          _c(
            "v-card",
            { attrs: { flat: "", tile: "" } },
            [
              _c(
                "v-card-text",
                { staticClass: "pa-md-4 pa-0" },
                [
                  _c("v-simple-table", {
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function() {
                          return [
                            _c("thead", [
                              _c("tr", { staticClass: "header-table" }, [
                                _c("th", { staticClass: "text-left" }, [
                                  _vm._v(_vm._s(_vm.$t("cart.product")))
                                ]),
                                _c("th", { staticClass: "text-right" }, [
                                  _vm._v(_vm._s(_vm.$t("cart.subtotal")))
                                ])
                              ])
                            ]),
                            _vm.cartProducts.length &&
                            _vm.cartProducts[0] !== null
                              ? _c(
                                  "tbody",
                                  [
                                    _vm._l(_vm.cartProducts, function(item) {
                                      return _c(
                                        "tr",
                                        {
                                          key: item.productId,
                                          staticClass: "grey--text"
                                        },
                                        [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(item.name) +
                                                " x " +
                                                _vm._s(item.qty)
                                            )
                                          ]),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "homepage.currency",
                                                      {
                                                        price: _vm.formatThousands(
                                                          _vm.getPrice(
                                                            item.amountWithVat,
                                                            item.qty
                                                          )
                                                        )
                                                      }
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    }),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        { staticClass: "header-item-title" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("cart.subtotal")) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "text-right primary--text"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("homepage.currency", {
                                                  price: _vm.formatThousands(
                                                    _vm.total
                                                  )
                                                })
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm.user && _vm.user.discount
                                      ? _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticClass: "header-item-title"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("cart.discount")
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "text-right primary--text"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "homepage.currency",
                                                      { price: _vm.discount }
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm.selectedShippingMethod
                                      ? _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticClass: "header-item-title"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("checkout.delivery")
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.selectedShippingMethod
                                                      .name
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm.selectedPaymentMethod
                                      ? _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticClass: "header-item-title"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("checkout.payment")
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.selectedPaymentMethod
                                                      .name
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("tr", { staticClass: "order-total" }, [
                                      _c("th", [
                                        _vm._v(_vm._s(_vm.$t("cart.total")))
                                      ]),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm.user && _vm.discount
                                          ? _c(
                                              "span",
                                              { staticClass: "primary--text" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "homepage.currency",
                                                        {
                                                          price: _vm.formatThousands(
                                                            _vm.totalDiscount
                                                          )
                                                        }
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              { staticClass: "primary--text" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "homepage.currency",
                                                      {
                                                        price: _vm.formatThousands(
                                                          _vm.total
                                                        )
                                                      }
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                      ])
                                    ])
                                  ],
                                  2
                                )
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }